import { SkeletonCard } from "@/components/ui/Skeleton";

const DEFAULT_CARD_COUNT = 7;

export const DashboardSkeleton = ({
  cardCount = DEFAULT_CARD_COUNT,
}: {
  cardCount?: number;
}) => (
  <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
    {Array.from({ length: cardCount }).map((_, i) => (
      <SkeletonCard key={i} />
    ))}
  </div>
);
